import React from 'react'
import { TypingLoaderStyles } from './Chat.styles'

function TypingLoader() {
  return (
    <TypingLoaderStyles className='loader'></TypingLoaderStyles>
  )
}

export default TypingLoader